import styled from 'styled-components'

/** Width constraints for the services search field (toolbar above the table). */
export const ServicesSearchContainer = styled.div`
  flex: 0 1 auto;
  width: min(36rem, 45vw);
  min-width: 21rem;
`

export const AttachmentDownloadLink = styled.a`
  color: ${({theme}) => theme.colors.primary.main};
  text-decoration: underline;
  cursor: pointer;
  font-size: ${({theme}) => theme.fontSize.sm};

  &:hover {
    opacity: 0.85;
  }

  &[aria-disabled='true'] {
    pointer-events: none;
    opacity: 0.5;
  }
`
